import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { MiddlePoint } from "@/types/stage";


export default /*@__PURE__*/_defineComponent({
  __name: 'MiddlePointComponent',
  props: {
    middlePoint: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_circle = _resolveComponent("v-circle")!

  return (props.middlePoint)
    ? (_openBlock(), _createBlock(_component_v_circle, {
        key: 0,
        config: {
      x: props.middlePoint.x,
      y: props.middlePoint.y,
      radius: 10,
      fill: 'orange',
      draggable: true,
    }
      }, null, 8, ["config"]))
    : _createCommentVNode("", true)
}
}

})